export default class Role {
    bgColor() {
        return this.color ? this.color : '#888888';
    }
}